import Api from "meta/features/api";
import VirtualPath from "meta/utils/virtualPath";
const notificationsBaseUrl = `${VirtualPath}/webapi/notifications`;
const api = Api({ baseURL: notificationsBaseUrl });
export default {
    loadNotifications: (noCache = false) => api.get(`load?noCache=${noCache}`),
    getNotificationDetails: () => api.get("details"),
    reloadEvents: () => api.get("reloadevents"),
};
